import { render, staticRenderFns } from "./CompomentLoader.vue?vue&type=template&id=6ce9b2f5&"
import script from "./CompomentLoader.vue?vue&type=script&lang=js&"
export * from "./CompomentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/opt/buildhome/repo/components/Breadcrumbs.vue').default,AggregateRating: require('/opt/buildhome/repo/components/AggregateRating.vue').default,CtaHero: require('/opt/buildhome/repo/components/global/CtaHero.vue').default,Steps: require('/opt/buildhome/repo/components/global/Steps.vue').default,LogoCloud: require('/opt/buildhome/repo/components/global/LogoCloud.vue').default,Faq: require('/opt/buildhome/repo/components/global/Faq.vue').default,Callout: require('/opt/buildhome/repo/components/global/Callout.vue').default,Testimonial: require('/opt/buildhome/repo/components/global/Testimonial.vue').default,Articles: require('/opt/buildhome/repo/components/global/Articles.vue').default,Features: require('/opt/buildhome/repo/components/global/Features.vue').default,ImageTextCombo: require('/opt/buildhome/repo/components/global/ImageTextCombo.vue').default,Gallery: require('/opt/buildhome/repo/components/global/Gallery.vue').default,Youtube: require('/opt/buildhome/repo/components/global/Youtube.vue').default,RelatedArticles: require('/opt/buildhome/repo/components/global/RelatedArticles.vue').default})
